// extracted by mini-css-extract-plugin
export default {"mCard":"az-z","image":"bz-z","imageNoBackground":"cz-z","imageHasCategory":"dz-z","fullWidth":"ez-z"};